import { Controller } from "stimulus"

const MIN_DISPLAY_MS = 300

export default class extends Controller {
  static targets = ["skeleton"]

  connect() {
    this.frame = this.element.querySelector("turbo-frame")
    if (!this.frame) return

    this.observer = new MutationObserver(this.busyChanged)
    this.observer.observe(this.frame, { attributes: true, attributeFilter: ["busy"] })
    this.frame.addEventListener("turbo:before-frame-render", this.beforeRender)
  }

  disconnect() {
    this.observer?.disconnect()
    this.frame?.removeEventListener("turbo:before-frame-render", this.beforeRender)
  }

  paginate() {
    window.scrollTo(0, 0)
  }

  busyChanged = () => {
    if (this.frame.hasAttribute("busy")) {
      this.shownAt = Date.now()
      this.skeletonTarget.classList.remove("hidden")
    }
  }

  beforeRender = (event) => {
    if (!this.shownAt) return

    const remaining = MIN_DISPLAY_MS - (Date.now() - this.shownAt)
    this.shownAt = null

    if (remaining > 0) {
      event.preventDefault()
      setTimeout(() => event.detail.resume(), remaining)
    }
  }
}
